import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import AdminLayout from "../../components/admin/AdminLayout";
import { Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";

const AdminFormulas = () => {
  const [formulas, setFormulas] = useState([]);
  const [search, setSearch] = useState("");

  const loadFormulas = async () => {
    try {
      const res = await api.get("/formulas");
      setFormulas(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const searchFormula = async () => {
    if (!search) return loadFormulas();

    const res = await api.get(
      `/formulas/search?q=${search}`
    );
    setFormulas(res.data);
  };

  const deleteFormula = async (id) => {
    if (!window.confirm("Bu formülü silmek istediğine emin misin?")) return;

    const token = localStorage.getItem("token");

    await api.delete(`/formulas/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    loadFormulas();
  };

  useEffect(() => {
    loadFormulas();
  }, []);

  return (
    <AdminLayout>
      <div className="d-flex justify-content-between align-items-center">
        <h2>🧪 Formül Yönetimi</h2>
        <Button as={Link} to="/admin/formulas/add" variant="primary">
          + Yeni Formül
        </Button>
      </div>

      <div className="mt-4">
        <Form className="d-flex mb-3" onSubmit={(e) => e.preventDefault()}>
          <Form.Control
            type="text"
            placeholder="Formül adı, içerik veya endikasyon ara..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <Button onClick={searchFormula} variant="primary" className="ms-2">
            Ara
          </Button>
        </Form>

        <table className="table table-striped">
          <thead>
            <tr>
              <th>Adı</th>
              <th>Endikasyon</th>
              <th>Eklenme Tarihi</th>
              <th>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {formulas.map((f) => (
              <tr key={f._id}>
                <td>{f.formulationName}</td>
                <td>{f.indication}</td>
                <td>{new Date(f.createdAt).toLocaleDateString()}</td>
                <td>
                  <Button
                    as={Link}
                    to={`/admin/formulas/edit/${f._id}`}
                    variant="warning"
                    size="sm"
                    className="me-2"
                  >
                    Düzenle
                  </Button>

                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => deleteFormula(f._id)}
                  >
                    Sil
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
};

export default AdminFormulas;
